// extracted by mini-css-extract-plugin
module.exports = {"blog":"blog_blog__pHMD0","blogCol":"blog_blogCol__39_De","postImage":"blog_postImage__DsiIz","label":"blog_label__3_Y8c"};